module.exports = __webpack_public_path__ + "static/media/panel.ia.2521fef9.png";